import { html as o } from "@microsoft/fast-element";
const r = o`
  <label class="control" part="control" for="${(l) => l.for}">
    <slot></slot>
  </label>
`;
export {
  r as labelTemplate
};
